import React from "react";
import { cn } from "@/lib/utils";

export function RoleBadge({ role, className }) {
  const isMaster = role === "master";
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={cn(
        "inline-flex items-center text-[10px] font-semibold px-2 py-0.5 rounded-sm uppercase tracking-[0.12em] border",
        isMaster
          ? "bg-[rgba(212,175,55,0.1)] text-[#D4AF37] border-[rgba(212,175,55,0.3)]"
          : "bg-[rgba(16,185,129,0.1)] text-[#10B981] border-[rgba(16,185,129,0.3)]",
        className,
      )}
    >
      {isMaster ? "Master" : "Connected"}
    </span>
  );
}

const STATUS_STYLES = {
  active: "bg-[rgba(16,185,129,0.12)] text-[#10B981] border-[rgba(16,185,129,0.3)]",
  unverified: "bg-[rgba(245,158,11,0.12)] text-[#F59E0B] border-[rgba(245,158,11,0.3)]",
  inactive: "bg-[#1A1A1A] text-[#737373] border-[#333333]",
  error: "bg-[rgba(239,68,68,0.12)] text-[#EF4444] border-[rgba(239,68,68,0.3)]",
};

export function StatusBadge({ status, className }) {
  const key = status === "active" ? "active" : status === "unverified" ? "unverified" : status === "error" ? "error" : "inactive";
  const label = { active: "Active", unverified: "Unverified", inactive: "Inactive", error: "Error" }[key];
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={cn("inline-flex items-center gap-1.5 text-[10px] font-medium px-2 py-0.5 rounded-sm uppercase tracking-wide border", STATUS_STYLES[key], className)}
    >
      <span className={cn("w-1.5 h-1.5 rounded-full", key === "active" ? "bg-[#10B981]" : key === "unverified" ? "bg-[#F59E0B]" : key === "error" ? "bg-[#EF4444]" : "bg-[#737373]")} />
      {label}
    </span>
  );
}

export function HealthDot({ status, showLabel = false, className }) {
  const verified = status === "active";
  const color = verified ? "#10B981" : status === "unverified" ? "#F59E0B" : "#737373";
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)} data-testid="health-dot"
      title={verified ? "Connection verified" : status === "unverified" ? "Not verified" : "Offline"}>
      <span className="relative flex w-2 h-2">
        {verified && <span className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping" style={{ background: color }} />}
        <span className="relative inline-flex rounded-full w-2 h-2" style={{ background: color }} />
      </span>
      {showLabel && <span className="text-[11px]" style={{ color }}>{verified ? "Verified" : status === "unverified" ? "Unverified" : "Offline"}</span>}
    </span>
  );
}
